import DOMPurify from "dompurify";
import { Marked } from "marked";
import { QUOTE_HREF } from "./quoteLinks.ts";
import { typography, type Language } from "./typography.ts";

// Les liens des réponses s'ouvrent dans un nouvel onglet, sans accès à la page du reader ;
// sauf les passages cités (#quote-N), qui ouvrent le livre.
DOMPurify.addHook("afterSanitizeAttributes", (node) => {
  if (node.tagName === "A" && !QUOTE_HREF.test(node.getAttribute("href") ?? "")) {
    node.setAttribute("target", "_blank");
    node.setAttribute("rel", "noopener noreferrer");
  }
});

const parsers: Partial<Record<Language | "none", Marked>> = {};
function parser(language: Language | undefined): Marked {
  const key = language ?? "none";
  const known = parsers[key];
  if (known) return known;
  const created = new Marked({ gfm: true, breaks: true });
  if (language) {
    // Texte seulement : ni le code, ni les adresses des liens.
    created.use({
      walkTokens(token) {
        if (token.type === "text" && !("tokens" in token && token.tokens?.length)) token.text = typography(token.text, language);
      },
    });
  }
  parsers[key] = created;
  return created;
}

/**
 * Réponses du chatbot en Markdown (titres, gras, listes, citations, tableaux), comme dans
 * l'app et le studio. Le HTML produit est toujours nettoyé : le texte vient d'un modèle.
 * `language` : la typographie de cette langue est appliquée au texte.
 */
export function renderMarkdown(source: string, language?: Language): string {
  const html = parser(language).parse(source, { async: false });
  return DOMPurify.sanitize(html, { USE_PROFILES: { html: true }, FORBID_TAGS: ["style", "img", "iframe", "form", "input"] });
}
